import { WorkOrderComplementType } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { isAppPortocar } from '@/index';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

const WorkOrderComplementTypeSelect = forwardRef(function (
  props: Omit<SelectProps, 'options'>,
) {
  const intl = useIntl();

  const options = Object.values(WorkOrderComplementType)
    .filter((type) =>
      isAppPortocar
        ? type !== WorkOrderComplementType.Revision &&
          type !== WorkOrderComplementType.TotalLoss
        : true,
    )
    .map((type) => ({
      label: intl.formatMessage({
        id: `workOrders.${
          isAppPortocar && type === WorkOrderComplementType.Courtesy
            ? 'domain.enums.work_order_type.insideCourtesy'
            : type
        }`,
      }),
      value: type,
    }));

  return (
    <Select allowClear style={{ width: '100%' }} {...props} options={options} />
  );
});

export default WorkOrderComplementTypeSelect;
